import { combineReducers } from 'redux';
import bdbDocumentsReducer from '../bdb-reducers/bdbDocumentsReducer';

export default combineReducers({
    documentsReducer: bdbDocumentsReducer
});